import { FilterType } from "../../model";
import { log } from "../../utils";
import { CobrowserKey } from "../capture/model";
const INPUT_UPDATE_KEY = `${CobrowserKey}_input_update`;
export class Input {
    constructor(page, listener) {
        this.page = page;
        this.listener = listener;
        this.inputhandler = (ev) => this.capture(ev);
        /** do not allow input when this is listening */
        this.focushandler = (ev) => { var _a, _b; return (_b = (_a = ev.target).blur) === null || _b === void 0 ? void 0 : _b.call(_a); };
        this.enabled = false;
        this.skipHook = false;
        this.updateInput = (target, update, options = [], win = window) => {
            var _a;
            if ((_a = update.selected) === null || _a === void 0 ? void 0 : _a.length) {
                const selected = new Set(options);
                Array.from(target.selectedOptions)
                    .concat(options)
                    .filter((opt) => opt)
                    .forEach((opt) => (opt.selected = selected.has(opt)));
            }
            else if (update.submit) {
                if (target.requestSubmit)
                    target.requestSubmit();
                else
                    target.dispatchEvent(new win.SubmitEvent("submit"));
            }
            else if (update.change) {
                target.dispatchEvent(new win.Event("change", { bubbles: true, cancelable: true }));
            }
            else {
                if (update.checked !== undefined) {
                    if (target.selected !== undefined)
                        target.selected = update.checked;
                    else
                        target.checked = update.checked;
                }
                if (update.value !== undefined) {
                    target.value = update.value;
                }
            }
        };
        this.unhooks = [];
        /** externalize internal target because event's target changes to the custom element */
        this.onShadowInput = (ev) => {
            // @ts-expect-error
            ev.internalTarget = ev.target;
        };
        this.onSubmit = (ev) => {
            ev.preventDefault();
            const target = this.page.idp.getId(ev.target);
            if (target && this.enabled)
                this.listener({
                    target,
                    submit: true,
                });
        };
        this.onChange = (ev) => {
            const target = this.page.idp.getId(ev.target);
            if (target && this.enabled)
                this.listener({
                    target,
                    change: true,
                });
        };
        if (!this.page.isOwner) {
            this.onFocus();
        }
        else {
            this.injectContext();
        }
    }
    injectContext() {
        this.page.getWindow()[INPUT_UPDATE_KEY] = this.updateInput.bind(this.page.getWindow());
        // if (!this.page.getWindow()[INPUT_UPDATE_KEY]) {
        //   const script = this.page.getDocument().createElement("script");
        //   script.innerHTML = `
        //     window.${INPUT_UPDATE_KEY}=${this.updateInput.toString()}
        //   `;
        //   this.page.getDocument().head.appendChild(script);
        //   script.remove();
        // }
    }
    onFocus() {
        this.page.getDocument().addEventListener("focus", this.focushandler, true);
    }
    offFocus() {
        this.page
            .getDocument()
            .removeEventListener("focus", this.focushandler, true);
    }
    /** check whether hook is overriden by setter on instance for every input tag name */
    hookInstance(target, key) {
        try {
            const desc = this.page
                .getWindow()
                .Object.getOwnPropertyDescriptor(target, key);
            // @ts-expect-error
            if ((desc === null || desc === void 0 ? void 0 : desc.set) && !desc.set._cobrowser) {
                this.unhooks.push(this.hookTarget(target, key));
            }
        }
        catch (ex) {
            log(ex);
        }
    }
    unhook() {
        this.unhooks.forEach((fn) => fn());
        this.unhooks = [];
    }
    hook() {
        try {
            this.unhook();
            const targets = [
                [this.page.getWindow().HTMLInputElement.prototype, "value"],
                [this.page.getWindow().HTMLInputElement.prototype, "checked"],
                [this.page.getWindow().HTMLSelectElement.prototype, "value"],
                [this.page.getWindow().HTMLTextAreaElement.prototype, "value"],
                [this.page.getWindow().HTMLOptionElement.prototype, "selected"],
            ];
            this.unhooks.push(...targets.map(([target, key]) => this.hookTarget(target, key)));
        }
        catch (ex) {
            log(ex);
        }
    }
    hookTarget(target, key) {
        try {
            const original = this.page
                .getWindow()
                .Object.getOwnPropertyDescriptor(target, key);
            const listener = (tar) => {
                if (this.enabled && !this.skipHook) {
                    setTimeout(() => {
                        this.capture({
                            target: tar,
                            timeStamp: Date.now(),
                        });
                    }, 0);
                }
            };
            const setter = function () {
                var _a;
                listener(this);
                return (_a = original.set) === null || _a === void 0 ? void 0 : _a.apply(this, arguments);
            };
            setter._cobrowser = true;
            this.page.getWindow().Object.defineProperty(target, key, {
                set: setter,
            });
            return () => {
                this.page.getWindow().Object.defineProperty(target, key, original);
            };
        }
        catch (ex) {
            log(ex);
            return () => { };
        }
    }
    /** track input updates */
    track(target) {
        if (target === this.page.getDocument()) {
            target.addEventListener("input", this.inputhandler);
        }
        else {
            target.addEventListener("input", this.onShadowInput);
            return;
        }
        if (!this.page.isOwner) {
            target.addEventListener("submit", this.onSubmit);
            target.addEventListener("change", this.onChange);
        }
        if (!this.enabled) {
            if (this.page.isOwner) {
                this.hook();
            }
            else {
                this.offFocus();
            }
            this.enabled = true;
        }
    }
    /** stop tracking updates */
    untrack() {
        var _a;
        if (this.page.isOwner) {
            this.unhook();
        }
        else {
            this.offFocus();
            this.onFocus();
        }
        (_a = this.page.getDocument()) === null || _a === void 0 ? void 0 : _a.removeEventListener("input", this.inputhandler);
        this.enabled = false;
    }
    dispatch(update) {
        var _a;
        const target = this.page.idp.getNode(update.target);
        if (!target) {
            return;
        }
        this.skipHook = true;
        const options = ((_a = update.selected) === null || _a === void 0 ? void 0 : _a.length)
            ? update.selected.map((id) => this.page.idp.getNode(id))
            : [];
        if (this.page.isOwner) {
            this.page
                .getWindow()[INPUT_UPDATE_KEY](target, update, options, this.page.getWindow());
        }
        else {
            this.updateInput(target, update, options, this.page.getWindow());
        }
        this.skipHook = false;
    }
    capture(ev) {
        var _a;
        const elm = 
        // @ts-expect-error
        ev.internalTarget || ev.target;
        if (elm.type === "file" || elm.type === "password") {
            return true;
        }
        const target = this.page.idp.getId(elm);
        if (target !== 0 &&
            // on renderer filtered inputs are disabled
            (!this.page.filter ||
                this.page.filter.getFilter(ev.target) ===
                    FilterType.None)) {
            const data = {
                target,
            };
            if (elm.selectedOptions) {
                data.selected = Array.from(elm.selectedOptions).map((opt) => this.page.idp.getId(opt));
            }
            else if (elm.selected !== undefined) {
                data.checked = elm.selected;
            }
            else {
                data.checked = elm.checked;
                data.value = elm.value;
            }
            // check for manual captures
            if (ev.timeStamp === undefined) {
                // ignore empty inputs
                if (!(((_a = data.selected) === null || _a === void 0 ? void 0 : _a.length) || data.checked === true || data.value)) {
                    return;
                }
                data.init = true;
            }
            this.listener(data);
        }
    }
}
